import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { TranslationLocale } from '../../../lib/types/enums/translation/translation.enum'
import { EnrollmentCharacteristicsInput } from '../../../lib/types/models/enrollment-characteristics/enrollment-characteristics-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createTranslationsSchema } from '../../../lib/utils/validations/translations-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form } from '../../elements/forms/form'
import TranslationsInput from '../../elements/inputs/translations-input'
import ValidationButtons from '../../elements/validation-buttons'

type Props = BaseFormProps<EnrollmentCharacteristicsInput> & {
  className?: string
}

const formSchema: ZodType<EnrollmentCharacteristicsInput> = z.object({
  translations: createTranslationsSchema([TranslationLocale.FR])
})

const EnrollmentCharacteristicsForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: Props) => {
  const form = useForm<EnrollmentCharacteristicsInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex gap-4 flex-col', className)}>
          <TranslationsInput
            control={form.control}
            name="translations"
            label="NOM"
            requiredLocales={[TranslationLocale.FR]}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default EnrollmentCharacteristicsForm
